import { render, staticRenderFns } from "./jumpComponent.vue?vue&type=template&id=a7dff928&scoped=true"
import script from "./jumpComponent.vue?vue&type=script&lang=js"
export * from "./jumpComponent.vue?vue&type=script&lang=js"
import style0 from "./jumpComponent.vue?vue&type=style&index=0&id=a7dff928&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7dff928",
  null
  
)

export default component.exports